import { FunctionComponent, ReactNode } from 'react'

export type AdjustableComponentProps<P, S> = P & {
  classes?: ClassesModifier<S>
  children?: ReactNode
}

export type AdjustableComponent<P, S> = FunctionComponent<AdjustableComponentProps<P, S>>

export type ClassesModifier<T> = (styles: T) => T

export const useClasses = <T extends { [key: string]: string }>(
  defaultStyles: T,
  classes?: ClassesModifier<T>,
) => {
  return classes ? classes(defaultStyles) : defaultStyles
}
